export class Profile {
  id?: number;
  targetGroup?: string;
  ldapUser?: boolean;
  customerNumber?: string;
  customerName?: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: any;
  email?: string;
  phone?: string;
  postalCode?: string;
  countryCode?: string;
  language?: string;
  avatar?: any;
  avatarContentType?: any;
  avatarName?: any;
  avatarSizeInBytes?: any;
  companyLogo?: any;
  contactPerson?: any;
  roles?: Array<string>;
  active?: boolean;

  constructor() {
    Object.assign(this);
  }
}
